module.exports = __webpack_public_path__ + "static/media/user-icon-decision.5de40d68.svg";